import { triggerHaptic } from "@/lib/nativeHaptics";

export type HomeWardrobeCtaState = "guest" | "auth-empty" | "auth-sparse";

interface Props {
  state: HomeWardrobeCtaState;
  onCtaTap: () => void;
}

const CORAL = "#C84B2F";
const INK = "#2C2820";
const MUTED = "#6B6560";

const coralBtn: React.CSSProperties = {
  background: CORAL,
  color: "#fff",
  borderRadius: 22,
  padding: "10px 20px",
  fontSize: 15,
  fontWeight: 600,
  border: "none",
  cursor: "pointer",
  marginTop: 14,
  minHeight: 44,
};

const COPY: Record<
  HomeWardrobeCtaState,
  { headline: string; body: string; cta: string }
> = {
  guest: {
    headline: "See looks with your wardrobe",
    body: "Sign up free to style every look with items you already own. Takes 10 seconds.",
    cta: "Sign up free",
  },
  "auth-empty": {
    headline: "Unlock wardrobe styling",
    body: "Add at least 3 wardrobe items to see every look styled with what you own.",
    cta: "Add wardrobe items →",
  },
  "auth-sparse": {
    headline: "Add more to your wardrobe",
    body: "The more you add, the better each look gets styled to your own pieces.",
    cta: "Add more items →",
  },
};

export default function HomeWardrobeCtaCard({ state, onCtaTap }: Props) {
  const copy = COPY[state];
  return (
    <section
      aria-label={copy.headline}
      style={{
        background: "linear-gradient(135deg, #FAECE7 0%, #FFFCF8 100%)",
        border: `1.5px dashed ${CORAL}`,
        borderRadius: 20,
        margin: "16px 16px 0",
        padding: 16,
        textAlign: "center",
      }}
    >
      <div
        style={{
          display: "inline-flex",
          gap: 4,
          marginBottom: 12,
        }}
        aria-hidden="true"
      >
        <div
          style={{
            width: 36,
            height: 48,
            background: "#EDE8E2",
            borderRadius: 4,
            transform: "rotate(-6deg)",
          }}
        />
        <div
          style={{
            width: 36,
            height: 48,
            background: "#C4A887",
            borderRadius: 4,
          }}
        />
        <div
          style={{
            width: 36,
            height: 48,
            background: "#6B4423",
            borderRadius: 4,
            transform: "rotate(6deg)",
          }}
        />
      </div>
      <div className="l2f-type-section-header" style={{ color: CORAL }}>
        STYLED WITH WHAT YOU OWN
      </div>
      <div
        style={{
          fontSize: 15,
          fontWeight: 500,
          color: INK,
          marginTop: 4,
        }}
      >
        {copy.headline}
      </div>
      <div
        className="l2f-type-caption"
        style={{
          color: MUTED,
          lineHeight: 1.5,
          marginTop: 6,
        }}
      >
        {copy.body}
      </div>
      <button
        type="button"
        style={coralBtn}
        onClick={() => {
          void triggerHaptic("primary-action");
          onCtaTap();
        }}
      >
        {copy.cta}
      </button>
    </section>
  );
}
